// opsService.js — admin Business-Operations API client.
// Mirrors outreachService.js auth/baseURL handling.
import { api } from './api';

const opsService = {
  async getSummary() {
    const response = await api.get('/admin/ops/summary');
    return response.data;
  },
  async uploadInvoice(file) {
    const form = new FormData();
    form.append('file', file);
    const res = await api.post('/admin/ops/invoices', form,
      { headers: { 'Content-Type': 'multipart/form-data' } });
    return res.data;
  },
  async listInvoices(status) {
    const res = await api.get('/admin/ops/invoices', { params: status ? { status } : {} });
    return res.data;
  },
  async getInvoice(id) {
    const res = await api.get(`/admin/ops/invoices/${id}`);
    return res.data;
  },
  async matchSuppliers(q) {
    const res = await api.get('/admin/ops/suppliers', { params: { q } });
    return res.data;
  },
  async createSupplier(payload) {
    const res = await api.post('/admin/ops/suppliers', payload);
    return res.data;
  },
  async approveInvoice(id, payload) {
    const res = await api.post(`/admin/ops/invoices/${id}/approve`, payload);
    return res.data;
  },
  async retryInvoice(id) {
    const res = await api.post(`/admin/ops/invoices/${id}/retry`);
    return res.data;
  },
  async receiveInvoice(id) {
    const res = await api.post(`/admin/ops/invoices/${id}/receive`);
    return res.data;
  },
  invoiceFileUrl(id) {
    return `${api.defaults.baseURL}/admin/ops/invoices/${id}/file`;
  },
  async worldpacStatus() {
    const res = await api.get('/admin/ops/worldpac/status');
    return res.data;
  },
  async worldpacSyncNow() {
    const res = await api.post('/admin/ops/worldpac/sync');
    return res.data;
  },
  async listOrders(source) {
    const res = await api.get('/admin/ops/orders', { params: source ? { source } : {} });
    return res.data;
  },
  async expensesSummary(from, to) {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    const res = await api.get('/admin/ops/expenses/summary', { params });
    return res.data;
  },
  async adsSummary(from, to, platform) {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    if (platform) params.platform = platform;
    const res = await api.get('/admin/ops/ads/summary', { params });
    return res.data;
  },
  async adsSources() {
    const res = await api.get('/admin/ops/ads/sources');
    return res.data;
  },
  async adsImport(rows) {
    const res = await api.post('/admin/ops/ads/import', { rows });
    return res.data;
  },
  async listInventory(q, lowStock) {
    const params = {};
    if (q) params.q = q;
    if (lowStock) params.low_stock = true;
    const res = await api.get('/admin/ops/inventory', { params });
    return res.data;
  },
  async inventorySummary() {
    const res = await api.get('/admin/ops/inventory/summary');
    return res.data;
  },
  async createInventoryItem(payload) {
    const res = await api.post('/admin/ops/inventory', payload);
    return res.data;
  },
  async updateInventoryItem(id, payload) {
    const res = await api.patch(`/admin/ops/inventory/${id}`, payload);
    return res.data;
  },
  async adjustInventory(id, payload) {
    const res = await api.post(`/admin/ops/inventory/${id}/adjust`, payload);
    return res.data;
  },
  async importInventoryCsv(file) {
    const form = new FormData();
    form.append('file', file);
    const res = await api.post('/admin/ops/inventory/import', form,
      { headers: { 'Content-Type': 'multipart/form-data' } });
    return res.data;
  },
  async financeAccounts() { return (await api.get('/admin/ops/finance/accounts')).data; },
  async financeCreateAccount(p) { return (await api.post('/admin/ops/finance/accounts', p)).data; },
  async financeSetMapping(id, m) { return (await api.put(`/admin/ops/finance/accounts/${id}/mapping`, m)).data; },
  async financePreview(id, file) {
    const f = new FormData(); f.append('file', file);
    return (await api.post(`/admin/ops/finance/accounts/${id}/preview`, f, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  async financeImport(id, file) {
    const f = new FormData(); f.append('file', file);
    return (await api.post(`/admin/ops/finance/accounts/${id}/import`, f, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
  async financeTransactions(params) { return (await api.get('/admin/ops/finance/transactions', { params })).data; },
  async financeSetTxnCategory(id, p) { return (await api.patch(`/admin/ops/finance/transactions/${id}`, p)).data; },
  async financeBulkCategorize(ids, category_id) { return (await api.post('/admin/ops/finance/transactions/categorize', { ids, category_id })).data; },
  async financeCategories() { return (await api.get('/admin/ops/finance/categories')).data; },
  async financeSummary(from, to) {
    const params = {}; if (from) params.from = from; if (to) params.to = to;
    return (await api.get('/admin/ops/finance/summary', { params })).data;
  },
  async financeRules() { return (await api.get('/admin/ops/finance/rules')).data; },
  async financeCreateRule(p) { return (await api.post('/admin/ops/finance/rules', p)).data; },
  async financeDeleteRule(id) { await api.delete(`/admin/ops/finance/rules/${id}`); },
};

export default opsService;
